(function () {
  "use strict";

  // Cambia el <h2.pushdaddy-title> por <p> manteniendo clases/atributos/contenido
  function replacePushdaddyH2() {
    try {
      // Ajusta el selector si tu DOM es distinto:
      // En tu captura se ve: <h2 class="pushdaddy-title">Hola</h2>
      var h2 = document.querySelector("h2.pushdaddy-title");
      if (!h2) return;

      // Evita re-ejecutar si ya lo cambiamos
      if (h2.dataset.headingReplaced === "1") return;

      var p = document.createElement("p");

      // Copiar clases y atributos
      p.className = h2.className;
      for (var i = 0; i < h2.attributes.length; i++) {
        var attr = h2.attributes[i];
        if (attr.name === "class") continue;
        if (attr.name === "data-heading-replaced") continue;
        p.setAttribute(attr.name, attr.value);
      }

      // Copiar contenido (incluye HTML si lo hubiera)
      p.innerHTML = h2.innerHTML;

      // Marcar como reemplazado (en el nuevo nodo)
      p.dataset.headingReplaced = "1";

      // Sustituir en DOM
      h2.parentNode.replaceChild(p, h2);
    } catch (e) {
      // Silencioso para no romper nada
      // console.warn("Heading fix failed:", e);
    }
  }

  // Ejecuta al cargar y también cuando Pushdaddy inyecte el widget
  function init() {
    replacePushdaddyH2();

    var obs = new MutationObserver(function () {
      replacePushdaddyH2();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Extra: reintentos por si el chat aparece muy tarde
    setTimeout(replacePushdaddyH2, 1000);
    setTimeout(replacePushdaddyH2, 3000);
    setTimeout(replacePushdaddyH2, 7000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();